import { render, staticRenderFns } from "./SummaryData.vue?vue&type=template&id=35686afe"
import script from "./SummaryData.vue?vue&type=script&lang=js"
export * from "./SummaryData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports